const NotFound = () => {
    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh'
            }}
        >
            <h1>Not Found Sorry O.O</h1>
        </div>
    )
}

export default NotFound;